export default __webpack_public_path__ + "static/media/ic_fail.f9e7378a.svg";